export { default as DefaultLarge } from '@/assets/graphics/splashes/default/large.svg';
export { default as DefaultMedium } from '@/assets/graphics/splashes/default/medium.svg';
export { default as DefaultSmall } from '@/assets/graphics/splashes/default/small.svg';
export { default as GolfLarge } from '@/assets/graphics/splashes/golf/large.svg';
export { default as GolfMedium } from '@/assets/graphics/splashes/golf/medium.svg';
export { default as GolfSmall } from '@/assets/graphics/splashes/golf/small.svg';
export { default as RejseklubbenLarge } from '@/assets/graphics/splashes/rejseklubben/large.svg';
export { default as RejseklubbenMedium } from '@/assets/graphics/splashes/rejseklubben/medium.svg';
export { default as RejseklubbenSmall } from '@/assets/graphics/splashes/rejseklubben/small.svg';
export { default as SafariLarge } from '@/assets/graphics/splashes/safari/large.svg';
export { default as SafariMedium } from '@/assets/graphics/splashes/safari/medium.svg';
export { default as SafariSmall } from '@/assets/graphics/splashes/safari/small.svg';

export type Theme = 'primary' | 'secondary' | 'tertiary';
